export const SET_SKIN = 'layout/SET_SKIN';